function getDate() {
    const calendarDate = $('#flatpickr-date').val().split('/');
    return moment().set({
        'year': calendarDate[2],
        'month': (calendarDate[1] -1),
        'date': calendarDate[0],
    });
}

function updateDates() {
    let date = getDate();
    let selectedDate = date.clone();
    const dateInfo = $('.calendario_horizontal').data('info');
    const dateEditionNumbers = $('.calendario_horizontal_edicoes').data('info');

    $('.dia-artigo').html(
        date.format('DD') +
        '/' +
        date.format('MM') +
        '/' +
        date.format('YYYY')
    );

    date.subtract(date.day(), 'days');
    const today = moment().endOf('day');

    $('.change-day-calendar').each(function() {
        let dateAdd = date;
        let day = dateAdd.date();
        let dayLong = date.format('dddd').replace(/-feira$/, '');
        let qtdEditions = 'Nenhuma edição';

        if (dateEditionNumbers[dateAdd.format('DD/MM/YYYY')]) {
            qtdEditions = dateEditionNumbers[dateAdd.format('DD/MM/YYYY')] + ' Edições';

            if (dateEditionNumbers[dateAdd.format('DD/MM/YYYY')] == 1) {
                qtdEditions = dateEditionNumbers[dateAdd.format('DD/MM/YYYY')] + ' Edição';
            }
        }

        $(this).find('.week_day_number_text').html(day);
        $(this).find('.week_day').html(dayLong.replace(/-feira$/, ''));
        $(this).find('.num_editions').html(qtdEditions);
        $(this).css('cursor', 'pointer');

        if (dateAdd.format('DD/MM/YYYY') == selectedDate.format('DD/MM/YYYY')) {
            $(this).addClass('dia_atual');
            $(this).removeClass('border-right-0');
            $(this).addClass('invalid-date');
        }

        if (dateAdd.endOf('day').diff(today, 'days') > 0) {
            $(this).addClass('invalid-date');
            $(this).css('cursor', 'default');
        } else if (dateInfo.includes(dateAdd.format('DD/MM/YYYY'))) {
            $(this).addClass('especial');
        }

        if (dateAdd.endOf('day').diff(today, 'days') == 0) {
            $(this).find('.week_day').html(dayLong.replace(/-feira$/, '') +  ' • Hoje');
        }

        $(this).find('input[type="hidden"]').val(date.format('DD/MM/YYYY'));
        dateAdd = date.add(1, 'days');
    });
}

function changeCalendar() {
    let date = getDate();
    location.href = '?date=' + date.format('YYYY-MM-DD');
}

$(function() {
    moment.locale('pt-br');

    const datepickerConfig = {
        locale: 'pt',
        wrap: true,
        enableTime: false,
        dateFormat: 'd/m/Y',
        maxDate: Date.now(),
        defaultDate: new Date($('#flatpickr-date-value').val()),
    };

    $('.flatpickr').flatpickr({
        ...datepickerConfig,
        onChange: (date) => {
            $('#flatpickr-date-value').on(moment(date).format('YYYY-MM-DD'))
        },
        onMonthChange: getEditionDate,
        onYearChange: getEditionDate,
        onOpen: getEditionDate,
    });

    updateDates();

    $('#flatpickr-date').on('change', function() {
        changeCalendar();
    });

    $('.change-day-calendar').on('click', function() {
        if ($(this).attr('class') == 'dia_atual') {
            return false;
        }

        if ($(this).hasClass('invalid-date')) {
            return false;
        }

        $('#flatpickr-date').val($(this).find('input[type="hidden"]').val());
        changeCalendar();
    });

    $('#next_week').on('click', function() {
        let date = getDate();
        const today = moment().endOf('day');
        date.add(1, 'week');
        if (date.endOf('day').diff(today, 'days') > 0) {
            return;
        }

        location.href = '?date=' + date.format('YYYY-MM-DD');
    });

    $('#previous_week').on('click', function() {
        let date = getDate();
        date.subtract(1, 'week');

        location.href = '?date=' + date.format('YYYY-MM-DD');
    });
});


function getEditionDate(date, selectedDate, instance) {
    var currentMonth = instance.currentMonth + 1;;

    axios.post(
        './edicao/dates',
        {
            month: currentMonth,
            year: instance.currentYear,
        }
    ).then(function (data) {
        if (
            typeof data.error_code !== 'undefined' ||
            data.status != 200
        ) {
            return false;
        }

        instance.config.enable = data?.['data']?.['data'] || [];
        instance.redraw();
    });
}